import React from 'react'
import { hydrateRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { getServerData } from '~/core/get-server-data'

import App from './components/List'
import { getStore } from './rtk/store'

const serverData = getServerData()
const store = getStore(serverData)

const rootElement = document.querySelector('#app')

if (!rootElement) throw new Error('Application root element was not found')

hydrateRoot(
    rootElement,
    <Provider store={store}>
        <App />
    </Provider>,
)
